/* @ngInject */
class ServiceUsers {
	constructor($http) {
		this.$http = $http;
	}

	get(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesNowHeadcount() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/now/headcount`,
		);
	}

	getSummariesNowRegions() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/now/regions`,
		);
	}

	getSummariesNowPrograms() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/now/programs`,
		);
	}

	getSummariesHistoricalHeadcount(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/historical/headcount`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesHistoricalRegions(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/historical/regions`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesExited(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/exited`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesHistoricalPrograms(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/summaries/historical/programs`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getOthersHighestId() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/others/highest-id`,
		);
	}

	getIndividualsActive() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/individuals/active`,
		);
	}

	getIndividualsInactive() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/individuals/inactive`,
		);
	}

	getIndividualsFinished() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/individuals/finished`,
		);
	}

	getIndividualsNDIS() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/individuals/ndis`,
		);
	}

	getIndividualsIcare() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/service-users/individuals/icare`,
		);
	}

	updateOneServiceUser(serviceUserId, data) {
		return this.$http.post(
			`${process.env.API_ENDPOINT}service-users/${serviceUserId}`, data,
		);
	}
}

export default ServiceUsers;


// WEBPACK FOOTER //
// ./src/js/services/staff/reports/serviceUsers/index.js